/**
 * @generated SignedSource<<0e19bc1b50769fa46f96eb8768254a62>>
 * @relayHash 0a1a87537f25dcee0d70c099bd8d0599
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 64af9e1568dc1937740b2784640274d7bae311a64c0f2afe75d902c4339e5722

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "64af9e1568dc1937740b2784640274d7bae311a64c0f2afe75d902c4339e5722",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
